module.exports = __webpack_public_path__ + "img/equal.03ee522b.png";